import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modals: [],
  isNavbarCollapsed: false,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (state, action) => {
      const modalId =
        action.payload.id || `modal-${Date.now()}-${Math.random()}`;
      const newModal = {
        id: modalId,
        isOpen: true,
        modalTitle: action.payload.title,
        modalContainerClass: action.payload.ContainerClass,
        minHeight: action.payload.minHeight,
        modalContent: action.payload.content,
        closable:
          action.payload.closable !== undefined
            ? action.payload.closable
            : true,
      };
      state.modals.push(newModal);
    },

    closeModal: (state, action) => {
      if (action.payload?.id) {
        state.modals = state.modals.filter(
          (modal) => modal.id !== action.payload.id
        );
      } else {
        state.modals.pop();
      }
    },

    closeAllModals: (state) => {
      state.modals = [];
    },

    updateModalContent: (state, action) => {
      const { id, content } = action.payload;
      const modal = state.modals.find((modal) => modal.id === id);
      if (modal) {
        modal.modalContent = content;
      }
    },

    toggleNavbar: (state) => {
      state.isNavbarCollapsed = !state.isNavbarCollapsed;
      document.body.classList.toggle("header-collapse");
    },
  },
});

export const {
  openModal,
  closeModal,
  closeAllModals,
  updateModalContent,
  toggleNavbar,
} = modalSlice.actions;

export default modalSlice.reducer;
